import { useSuspenseQuery } from "@tanstack/react-query";

import { getConfig } from "lib/get-config";
import type { Xpointer } from "lib/types";

import { getChapters } from "./get-chapters";

export function useChangedChapters(enabled: boolean): Set<Xpointer> {
  const { art } = getConfig();

  const { data } = useSuspenseQuery({
    queryKey: ["chapters", art, enabled],
    queryFn: () => (enabled ? getChapters(art) : []),
    select: chapters =>
      new Set<Xpointer>(
        chapters
          .filter(ch => ch.is_changed && ch.xpointer_start)
          .map(ch => ch.xpointer_start!)
      ),
  });

  return data;
}
